import {
    ENTITY_REDUCER_KEY
} from './schemas'

const entityReducer = (state = {}) => state;

export const entityReducers = {
    [ENTITY_REDUCER_KEY]: entityReducer,
};
